export const colorDefinition = {
  black: '#000000',
  white: '#FFFFFF',
  gray: {
    ZERO: '#FAFBFC',
    50: '#F7F9FA',
    100: '#F1f3f5',
    200: '#E1E4E8',
    300: '#D1D5DA',
    400: '#959DA5',
    500: '#6A737D',
    600: '#586069',
    700: '#444D56',
    800: '#2F363D',
    900: '#24292E',
  },
  blue: {
    ZERO: '#F1F8FF',
    100: '#DBEDFF',
    200: '#C8E1FF',
    300: '#79B8FF',
    400: '#2188FF',
    500: '#0366D6',
    600: '#005CC5',
    700: '#044289',
    800: '#032F62',
    900: '#05264C',
  },
  green: {
    ZERO: '#F0FFF4',
    100: '#DCFFE4',
    200: '#BEF5CB',
    300: '#85E89D',
    400: '#34D058',
    500: '#28A745',
    600: '#22863A',
    700: '#176F2C',
    800: '#165C26',
    900: '#144620',
  },
  yellow: {
    ZERO: '#FFFDEF',
    100: '#FFFBDD',
    200: '#FFF5B1',
    300: '#FFEA7F',
    400: '#FFDF5D',
    500: '#FFD33D',
    600: '#F9C513',
    700: '#DBAB09',
    800: '#B08800',
    900: '#735C0F',
  },
  orange: {
    ZERO: '#FFF8F2',
    100: '#FFEBDA',
    200: '#FFD1AC',
    300: '#FFAB70',
    400: '#FB8532',
    500: '#F66A0A',
    600: '#E36209',
    700: '#D15704',
    800: '#C24E00',
    900: '#A04100',
  },
  red: {
    ZERO: '#FFEEF0',
    100: '#FFDCE0',
    200: '#FDAEB7',
    300: '#F97583',
    400: '#EA4A5A',
    500: '#D73A49',
    600: '#CB2431',
    700: '#B31D28',
    800: '#9E1C23',
    900: '#86181D',
  },
  pink: {
    ZERO: '#FFEEF8',
    100: '#FEDBF0',
    200: '#F9B3DD',
    300: '#F692CE',
    400: '#EC6CB9',
    500: '#EA4AAA',
    600: '#D03592',
    700: '#B93A86',
    800: '#99306F',
    900: '#6D224F',
  },
  purple: {
    ZERO: '#F5F0FF',
    100: '#E6DCFD',
    200: '#D1BCF9',
    300: '#B392F0',
    400: '#8A63D2',
    500: '#6F42C1',
    600: '#5A32A3',
    700: '#4C2888',
    800: '#3A1D6E',
    900: '#29134E',
  },
  cyan: {
    ZERO: '#DEFAFF',
    100: '#B3EBF7',
    200: '#81DEF2',
    300: '#57DFF7',
    400: '#28D0ED',
    500: '#00BDDE',
    600: '#00ADCA',
    700: '#0098B2',
    800: '#008497',
    900: '#00616B',
  },
  magenta: {
    ZERO: '#EFE9FD',
    100: '#D5C8FB',
    200: '#B9A4F9',
    300: '#9B7DF8',
    400: '#815FF5',
    500: '#6441F2',
    600: '#573CEB',
    700: '#4334E2',
    800: '#2C2EDC',
    900: '#0021D3',
  },
};

export interface IColorSet {
  'text-gray-light': string;
  'text-gray-lighter': string;
  'text-gray-main': string;
  'text-gray-sub-darker': string;
  'text-gray-sub-dark': string;
  'text-gray-sub-light': string;
  'text-gray-sub-lighter': string;
  'text-white': string;
  'text-w-opacity-60%': string;
  'text-blue-light': string;
  'text-blue': string;
  'text-green': string;
  'text-green-light': string;
  'text-green-dark': string;
  'text-yellow': string;
  'text-orange': string;
  'text-red-dark': string;
  'text-red': string;
  'text-red-light': string;
  'text-red-lighter': string;
  'text-pink': string;
  'text-purple-light': string;
  'text-purple': string;
  'text-black': string;
  'text-gradient': string;
  'text-yellow-light': string;
  'text-yellow-dark': string;
  'text-cyan': string;
  'text-meganta': string;
  'border-white': string;
  'border-gray-w-lighter': string;
  'border-gray-lighter': string;
  'border-gray-light': string;
  'border-gray-dark': string;
  'border-gray-darker': string;
  'border-bk-opacity-10%': string;
  'border-bk-opacity-15%': string;
  'border-w-opacity-30%': string;
  'border-blue': string;
  'border-green': string;
  'border-green-light': string;
  'border-yellow': string;
  'border-orange': string;
  'border-red': string;
  'border-red-light': string;
  'border-red-lighter': string;
  'border-red-lighter-more': string;
  'border-pink': string;
  'border-purple': string;
  'border-purple-dark': string;
  'border-purple-lighter': string;
  'border-purple-light': string;
  'border-gradient': string;
  'bg-white': string;
  'bg-gray-lighter': string;
  'bg-gray-light': string;
  'bg-gray-light-50': string;
  'bg-gray-light-m': string;
  'bg-gray-light-gradient-90': string;
  'bg-gray-dark': string;
  'bg-gray-dark-50': string;
  'bg-gray-darker': string;
  'bg-gray-main': string;
  'bg-bk-opacity-40%': string;
  'bg-bk-opacity-60%': string;
  'bg-bk-opacity-80%': string;
  'bg-bk-opacity-85%': string;
  'bg-blue-lighter': string;
  'bg-blue-light': string;
  'bg-blue-dark': string;
  'bg-blue-dark-40': string;
  'bg-green': string;
  'bg-green-lighter': string;
  'bg-green-light': string;
  'bg-yellow-lighter': string;
  'bg-yellow-light': string;
  'bg-yellow': string;
  'bg-orange-lighter': string;
  'bg-red-light': string;
  'bg-red-lighter': string;
  'bg-pink-lighter': string;
  'bg-pink': string;
  'bg-purple': string;
  'bg-purple-lighter': string;
  'bg-purple-light': string;
  'bg-purple-light-50': string;
  'bg-purple-dark': string;
  'bg-gradient': string;
  'bg-w-gradient': string;
  'ic-w-opacity-60%': string;
  'ic-white': string;
  'ic-gray-lighter': string;
  'ic-gray-light': string;
  'ic-gray-dark': string;
  'ic-gray-main': string;
  'ic-green': string;
  'ic-green-light': string;
  'ic-pink-light': string;
  'ic-purple': string;
  'ic-purple-light': string;
  'ic-red-light': string;
  'ic-red-dark': string;
  'ic-yellow-dark': string;
  'ic-blue-dark': string;
  'ic-blue-light': string;
  'state-white-hover': string;
  'state-white-pressed': string;
  'state-white-purple-hover': string;
  'state-white-purple-pressed': string;
  'state-purple-hover': string;
  'state-purple-pressed': string;
  'state-gradient-hover': string;
  'state-gradient-pressed': string;
  'graph-green': string;
  'graph-green-light': string;
  'graph-yellow': string;
  'graph-yellow-lighter': string;
  'graph-orange': string;
  'graph-orange-lighter': string;
  'graph-blue': string;
  'graph-blue-light': string;
  'graph-gray': string;
  'graph-gray-light': string;
  'graph-gray-m-light': string;
  'graph-gray-lighter': string;
  'graph-gray-dark': string;
  'graph-purple': string;
  'graph-purple-light': string;
  'graph-purple-lighter': string;
  'graph-purple-gradient': string;
  'graph-pink': string;
  // 추가된 것 25/09/08 KT_DS Design System 참고
  'hd-pt-bg-1depth': string;
  'hd-pt-bg-2depth': string;
  'hd-ad-bg-1depth': string;
  'hd-ad-bg-2depth': string;
  'hd-pt-logo': string;
  'hd-pt-logo-text': string;
  'hd-pt-1depth-text-normal': string;
  'hd-pt-1depth-text-select': string;
  'hd-pt-2depth-text-normal': string;
  'hd-pt-2depth-text-select': string;
  'hd-ad-2depth-text-normal': string;
  'hd-ad-2depth-text-select': string;
  'hd-pt-border-select': string;
  'hd-pt-ic-dot-opacity-60%': string;
  'hd-ad-ic-dot-opacity-60%': string;
  'bg-primary-opacity-40%': string;
  'bg-secondary-lighter': string;
  'bg-primary-lighter': string;
  'bg-primary-light': string;
  'bg-primary': string;
  'bg-primary-dark': string;
  'bg-secondary': string;
  'bg-primary-light-50': string;
  'bg-cyan': string;
  'bg-cyan-light': string;
  'bg-meganta': string;
  'state-white-primary-hover': string;
  'state-white-primary-pressed': string;
  'state-primary-hover': string;
  'state-primary-pressed': string;
  'border-secondary': string;
  'border-primary-light': string;
  'border-primary': string;
  'border-primary-dark': string;
  'ic-primary-light': string;
  'ic-primary': string;
  'ic-secondary-light': string;
  'text-secondary': string;
  'text-primary': string;
  'text-primary-light': string;
  'graph-primary': string;
  'graph-primary-light': string;
  'graph-primary-lighter': string;
  'graph-secondary': string;
  'graph-secondary-light': string;
  'primary-000-40%': string;
  'primary-200-20%': string;
  'primary-200-0%': string;
}

type ModeType = 'dark' | 'light';

/**
 * Default Colors Set
 */
export const colors: { [key in ModeType]: IColorSet } = {
  dark: {
    'text-gray-light': colorDefinition.gray[400],
    'text-gray-lighter': colorDefinition.gray[300],
    'text-gray-main': colorDefinition.gray[900],
    'text-gray-sub-darker': colorDefinition.gray[700],
    'text-gray-sub-dark': colorDefinition.gray[500],
    'text-gray-sub-light': colorDefinition.gray[400],
    'text-gray-sub-lighter': colorDefinition.gray[300],
    'text-white': colorDefinition.white,
    'text-w-opacity-60%': 'rgba(255, 255, 255, 0.6)',
    'text-blue-light': colorDefinition.blue[400],
    'text-blue': colorDefinition.blue[700],
    'text-green': colorDefinition.green[700],
    'text-green-light': colorDefinition.green[400],
    'text-green-dark': colorDefinition.green[800],
    'text-yellow': colorDefinition.yellow[800],
    'text-orange': colorDefinition.orange[700],
    'text-red-dark': colorDefinition.red[800],
    'text-red': colorDefinition.red[600],
    'text-red-light': colorDefinition.red[400],
    'text-red-lighter': colorDefinition.red[100],
    'text-pink': colorDefinition.pink[600],
    'text-purple-light': colorDefinition.purple[500],
    'text-purple': colorDefinition.purple[700],
    'text-cyan': colorDefinition.cyan[800],
    'text-meganta': colorDefinition.magenta[600],
    'text-gradient': `linear-gradient(to left, ${colorDefinition.purple[500]} 0%, ${colorDefinition.pink[700]} 100% )`,
    'text-yellow-light': colorDefinition.yellow[300],
    'text-yellow-dark': colorDefinition.yellow[900],
    'border-white': colorDefinition.white,
    'border-gray-w-lighter': colorDefinition.gray[100],
    'border-gray-lighter': colorDefinition.gray[200],
    'border-gray-light': colorDefinition.gray[300],
    'border-gray-dark': colorDefinition.gray[400],
    'border-gray-darker': colorDefinition.gray[900],
    'border-bk-opacity-10%': 'rgba(0, 0, 0, 0.1)',
    'border-bk-opacity-15%': 'rgba(0, 0, 0, 0.15)',
    'border-blue': colorDefinition.blue[500],
    'border-green': colorDefinition.green[500],
    'border-green-light': colorDefinition.green[300],
    'border-yellow': colorDefinition.yellow[700],
    'border-orange': colorDefinition.orange[600],
    'border-red-lighter': colorDefinition.red[200],
    'border-red-lighter-more': colorDefinition.red[100],
    'border-red-light': colorDefinition.red[400],
    'border-red': colorDefinition.red[500],
    'border-pink': colorDefinition.pink[500],
    'border-purple': colorDefinition.purple[500],
    'border-purple-dark': colorDefinition.purple[600],
    'border-purple-lighter': colorDefinition.purple[200],
    'border-purple-light': colorDefinition.purple[200],
    'border-gradient': `linear-gradient(to left, ${colorDefinition.purple[500]} 0%, ${colorDefinition.pink[700]} 100% )`,
    'border-w-opacity-30%': 'rgba(255,255,255, 0.3)',
    'bg-white': colorDefinition.white,
    'bg-gray-lighter': colorDefinition.gray.ZERO,
    'bg-gray-light': colorDefinition.gray[100],
    'bg-gray-light-50': colorDefinition.gray[50],
    'bg-gray-light-m': colorDefinition.gray[200],
    'bg-gray-light-gradient-90': `linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, ${colorDefinition.gray.ZERO} 49%)`,
    'bg-gray-dark': colorDefinition.gray[300],
    'bg-gray-dark-50': colorDefinition.gray[500],
    'bg-gray-darker': colorDefinition.gray[600],
    'bg-gray-main': colorDefinition.gray[900],
    'bg-bk-opacity-40%': 'rgba(0, 0, 0, 0.4)',
    'bg-bk-opacity-60%': 'rgba(0, 0, 0, 0.6)',
    'bg-bk-opacity-80%': 'rgba(0, 0, 0, 0.8)',
    'bg-bk-opacity-85%': 'rgba(0, 0, 0, 0.85)',
    'bg-blue-lighter': colorDefinition.blue[100],
    'bg-blue-light': colorDefinition.blue[200],
    'bg-blue-dark-40': colorDefinition.blue[400],
    'bg-blue-dark': colorDefinition.blue[500],
    'bg-green': colorDefinition.green[500],
    'bg-green-lighter': colorDefinition.green[100],
    'bg-green-light': colorDefinition.green[100],
    'bg-yellow-lighter': colorDefinition.yellow[100],
    'bg-yellow-light': colorDefinition.yellow[200],
    'bg-yellow': colorDefinition.yellow[300],
    'bg-orange-lighter': colorDefinition.orange[100],
    'bg-red-light': colorDefinition.red[400],
    'bg-red-lighter': colorDefinition.red.ZERO,
    'bg-pink-lighter': colorDefinition.pink.ZERO,
    'bg-pink': colorDefinition.pink[500],
    'bg-purple-lighter': colorDefinition.purple.ZERO,
    'bg-purple-light': colorDefinition.purple[500],
    'bg-purple-light-50': colorDefinition.purple[200],
    'bg-purple': colorDefinition.purple[600],
    'bg-purple-dark': colorDefinition.purple[700],
    'bg-gradient': `linear-gradient(to left, ${colorDefinition.purple[500]} 0%, ${colorDefinition.pink[700]} 100% )`,
    'bg-w-gradient': `linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 60.94%)`,
    'ic-w-opacity-60%': 'rgba(255, 255, 255, 0.6)',
    'ic-white': colorDefinition.white,
    'ic-gray-lighter': colorDefinition.gray[300],
    'ic-gray-light': colorDefinition.gray[400],
    'ic-gray-dark': colorDefinition.gray[500],
    'ic-gray-main': colorDefinition.gray[900],
    'ic-green': colorDefinition.green[500],
    'ic-green-light': colorDefinition.green[400],
    'ic-pink-light': colorDefinition.pink[400],
    'ic-purple-light': colorDefinition.purple[500],
    'ic-purple': colorDefinition.purple[600],
    'ic-red-light': colorDefinition.red[400],
    'ic-red-dark': colorDefinition.red[600],
    'ic-yellow-dark': colorDefinition.yellow[600],
    'ic-blue-dark': colorDefinition.blue[600],
    'ic-blue-light': colorDefinition.blue[400],
    'text-black': colorDefinition.black,
    'state-white-hover': '#F6F6F7',
    'state-white-pressed': '#EDEEEE',
    'state-white-purple-hover': '#F6F6F7',
    'state-white-purple-pressed': '#F3F0FA',
    'state-purple-hover': '#643EA9',
    'state-purple-pressed': '#6B47AC',
    'state-gradient-hover': 'linear-gradient(90deg, #A6357A 0%, #653CAE 100%)',
    'state-gradient-pressed': 'linear-gradient(90deg, #9D3273 0%, #5F39A4 100%);',
    'graph-green': colorDefinition.green[400],
    'graph-green-light': colorDefinition.green[300],
    'graph-yellow': colorDefinition.yellow[400],
    'graph-yellow-lighter': colorDefinition.yellow[100],
    'graph-orange': colorDefinition.orange[300],
    'graph-orange-lighter': colorDefinition.orange[100],
    'graph-blue': colorDefinition.blue[400],
    'graph-blue-light': colorDefinition.blue[300],
    'graph-gray': colorDefinition.gray[300],
    'graph-gray-light': colorDefinition.gray[200],
    'graph-gray-m-light': colorDefinition.gray[100],
    'graph-gray-lighter': colorDefinition.gray.ZERO,
    'graph-purple': colorDefinition.purple[500],
    'graph-purple-light': colorDefinition.purple[400],
    'graph-purple-lighter': colorDefinition.purple[200],
    'graph-purple-gradient': colorDefinition.purple[100],
    'graph-pink': colorDefinition.pink[500],
    'graph-gray-dark': colorDefinition.gray[400],
    // 추가된 것 25/09/08 KT_DS Design System 참고
    'hd-pt-bg-1depth': colorDefinition.white,
    'hd-pt-bg-2depth': colorDefinition.purple[700],
    'hd-ad-bg-1depth': colorDefinition.gray[900],
    'hd-ad-bg-2depth': colorDefinition.purple[700],
    'hd-pt-logo': colorDefinition.gray[900],
    'hd-pt-logo-text': colorDefinition.gray[900],
    'hd-pt-1depth-text-normal': colorDefinition.gray[700],
    'hd-pt-1depth-text-select': colorDefinition.gray[900],
    'hd-pt-2depth-text-normal': colorDefinition.gray[200],
    'hd-pt-2depth-text-select': colorDefinition.white,
    'hd-ad-2depth-text-normal': colorDefinition.gray[200],
    'hd-ad-2depth-text-select': colorDefinition.white,
    'hd-pt-border-select': colorDefinition.gray[900],
    'hd-pt-ic-dot-opacity-60%': colorDefinition.white,
    'hd-ad-ic-dot-opacity-60%': colorDefinition.white,
    'bg-primary-opacity-40%': 'rgb(245, 240 ,255 ,40%)',
    'bg-secondary-lighter': colorDefinition.pink.ZERO,
    'bg-primary-lighter': colorDefinition.purple.ZERO,
    'bg-primary-light': colorDefinition.purple[500],
    'bg-primary': colorDefinition.purple[600],
    'bg-primary-dark': colorDefinition.purple[700],
    'bg-secondary': colorDefinition.pink[500],
    'bg-primary-light-50': colorDefinition.purple[200],
    'bg-cyan': colorDefinition.cyan[600],
    'bg-cyan-light': colorDefinition.cyan[400],
    'bg-meganta': colorDefinition.magenta[500],
    'state-white-primary-hover': '#F6F6F7',
    'state-white-primary-pressed': '#F3F0FA',
    'state-primary-hover': '#643EA9',
    'state-primary-pressed': '#6B47AC',
    'border-secondary': colorDefinition.pink[500],
    'border-primary-light': colorDefinition.purple[200],
    'border-primary': colorDefinition.purple[500],
    'border-primary-dark': colorDefinition.purple[600],
    'ic-primary-light': colorDefinition.purple[500],
    'ic-primary': colorDefinition.purple[600],
    'ic-secondary-light': colorDefinition.pink[400],
    'text-secondary': colorDefinition.pink[600],
    'text-primary': colorDefinition.purple[700],
    'text-primary-light': colorDefinition.purple[500],
    'graph-primary': colorDefinition.purple[500],
    'graph-primary-light': colorDefinition.purple[400],
    'graph-primary-lighter': colorDefinition.purple[200],
    'graph-secondary': colorDefinition.pink[500],
    'graph-secondary-light': colorDefinition.pink[300],
    'primary-000-40%': 'rgba(245, 240 ,255 ,40%)',
    'primary-200-20%': 'rgba(209, 188 ,249 ,20%)',
    'primary-200-0%': 'rgba(209,188,249 ,0%)',
  },
  light: {
    'text-gray-light': colorDefinition.gray[400],
    'text-gray-lighter': colorDefinition.gray[300],
    'text-gray-main': colorDefinition.gray[900],
    'text-gray-sub-darker': colorDefinition.gray[700],
    'text-gray-sub-dark': colorDefinition.gray[500],
    'text-gray-sub-light': colorDefinition.gray[400],
    'text-gray-sub-lighter': colorDefinition.gray[300],
    'text-white': colorDefinition.white,
    'text-w-opacity-60%': 'rgba(255, 255, 255, 0.6)',
    'text-blue-light': colorDefinition.blue[400],
    'text-blue': colorDefinition.blue[700],
    'text-green': colorDefinition.green[700],
    'text-green-light': colorDefinition.green[400],
    'text-green-dark': colorDefinition.green[800],
    'text-yellow': colorDefinition.yellow[800],
    'text-yellow-dark': colorDefinition.yellow[900],
    'text-orange': colorDefinition.orange[800],
    'text-red-dark': colorDefinition.red[800],
    'text-red': colorDefinition.red[600],
    'text-red-light': colorDefinition.red[400],
    'text-red-lighter': colorDefinition.red[100],
    'text-pink': colorDefinition.pink[700],
    'text-purple-light': colorDefinition.purple[500],
    'text-purple': colorDefinition.purple[700],
    'text-cyan': colorDefinition.cyan[800],
    'text-meganta': colorDefinition.magenta[600],
    'text-gradient': `linear-gradient(to left, ${colorDefinition.purple[500]} 0%, ${colorDefinition.pink[700]} 100% )`,
    'text-yellow-light': colorDefinition.yellow[300],
    'border-white': colorDefinition.white,
    'border-gray-w-lighter': colorDefinition.gray[100],
    'border-gray-lighter': colorDefinition.gray[200],
    'border-gray-light': colorDefinition.gray[300],
    'border-gray-dark': colorDefinition.gray[400],
    'border-gray-darker': colorDefinition.gray[900],
    'border-bk-opacity-10%': 'rgba(0, 0, 0, 0.1)',
    'border-bk-opacity-15%': 'rgba(0, 0, 0, 0.15)',
    'border-blue': colorDefinition.blue[500],
    'border-green': colorDefinition.green[500],
    'border-green-light': colorDefinition.green[300],
    'border-yellow': colorDefinition.yellow[700],
    'border-orange': colorDefinition.orange[600],
    'border-red-lighter': colorDefinition.red[200],
    'border-red-lighter-more': colorDefinition.red[100],
    'border-red-light': colorDefinition.red[400],
    'border-red': colorDefinition.red[500],
    'border-pink': colorDefinition.pink[500],
    'border-purple': colorDefinition.purple[500],
    'border-purple-dark': colorDefinition.purple[600],
    'border-purple-lighter': colorDefinition.purple[200],
    'border-purple-light': colorDefinition.purple[200],
    'border-w-opacity-30%': 'rgba(255,255,255, 0.3)',
    'border-gradient': `linear-gradient(to left, ${colorDefinition.purple[500]} 0%, ${colorDefinition.pink[700]} 100% )`,
    'bg-white': colorDefinition.white,
    'bg-gray-lighter': colorDefinition.gray.ZERO,
    'bg-gray-light': colorDefinition.gray[100],
    'bg-gray-light-50': colorDefinition.gray[50],
    'bg-gray-light-m': colorDefinition.gray[200],
    'bg-gray-light-gradient-90': `linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, ${colorDefinition.gray.ZERO} 49%)`,
    'bg-gray-dark': colorDefinition.gray[300],
    'bg-gray-dark-50': colorDefinition.gray[500],
    'bg-gray-darker': colorDefinition.gray[600],
    'bg-gray-main': colorDefinition.gray[900],
    'bg-bk-opacity-40%': 'rgba(0, 0, 0, 0.4)',
    'bg-bk-opacity-60%': 'rgba(0, 0, 0, 0.6)',
    'bg-bk-opacity-80%': 'rgba(0, 0, 0, 0.8)',
    'bg-bk-opacity-85%': 'rgba(0, 0, 0, 0.85)',
    'bg-blue-lighter': colorDefinition.blue[100],
    'bg-blue-light': colorDefinition.blue[200],
    'bg-blue-dark': colorDefinition.blue[500],
    'bg-blue-dark-40': colorDefinition.blue[400],
    'bg-green': colorDefinition.green[500],
    'bg-green-lighter': colorDefinition.green[100],
    'bg-green-light': colorDefinition.green[100],
    'bg-yellow-lighter': colorDefinition.yellow[100],
    'bg-yellow-light': colorDefinition.yellow[200],
    'bg-yellow': colorDefinition.yellow[300],
    'bg-orange-lighter': colorDefinition.orange[100],
    'bg-red-light': colorDefinition.red[400],
    'bg-red-lighter': colorDefinition.red.ZERO,
    'bg-pink-lighter': colorDefinition.pink.ZERO,
    'bg-pink': colorDefinition.pink[500],
    'bg-purple-lighter': colorDefinition.purple.ZERO,
    'bg-purple-light': colorDefinition.purple[500],
    'bg-purple-light-50': colorDefinition.purple[200],
    'bg-purple': colorDefinition.purple[600],
    'bg-purple-dark': colorDefinition.purple[700],
    'bg-gradient': `linear-gradient(to left, ${colorDefinition.purple[500]} 0%, ${colorDefinition.pink[700]} 100% )`,
    'bg-w-gradient': `linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 60.94%)`,
    'ic-w-opacity-60%': 'rgba(255, 255, 255, 0.6)',
    'ic-white': colorDefinition.white,
    'ic-gray-lighter': colorDefinition.gray[300],
    'ic-gray-light': colorDefinition.gray[400],
    'ic-gray-dark': colorDefinition.gray[500],
    'ic-gray-main': colorDefinition.gray[900],
    'ic-green': colorDefinition.green[500],
    'ic-green-light': colorDefinition.green[400],
    'ic-pink-light': colorDefinition.pink[400],
    'ic-purple-light': colorDefinition.purple[500],
    'ic-purple': colorDefinition.purple[600],
    'ic-red-light': colorDefinition.red[400],
    'ic-red-dark': colorDefinition.red[600],
    'ic-yellow-dark': colorDefinition.yellow[600],
    'ic-blue-dark': colorDefinition.blue[600],
    'ic-blue-light': colorDefinition.blue[400],
    'text-black': colorDefinition.black,
    'state-white-hover': '#F6F6F7',
    'state-white-pressed': '#EDEEEE',
    'state-white-purple-hover': '#F9F7FD',
    'state-white-purple-pressed': '#F3F0FA',
    'state-purple-hover': '#643EA9',
    'state-purple-pressed': '#6B47AC',
    'state-gradient-hover': `linear-gradient(90deg, #A6357A 0%, #653CAE 100%);`,
    'state-gradient-pressed': 'linear-gradient(90deg, #9D3273 0%, #5F39A4 100%);',
    'graph-green': colorDefinition.green[400],
    'graph-green-light': colorDefinition.green[300],
    'graph-yellow': colorDefinition.yellow[400],
    'graph-yellow-lighter': colorDefinition.yellow[100],
    'graph-orange': colorDefinition.orange[300],
    'graph-orange-lighter': colorDefinition.orange[100],
    'graph-blue': colorDefinition.blue[400],
    'graph-blue-light': colorDefinition.blue[300],
    'graph-gray': colorDefinition.gray[300],
    'graph-gray-light': colorDefinition.gray[200],
    'graph-gray-m-light': colorDefinition.gray[100],
    'graph-gray-lighter': colorDefinition.gray.ZERO,
    'graph-purple': colorDefinition.purple[500],
    'graph-purple-light': colorDefinition.purple[400],
    'graph-purple-lighter': colorDefinition.purple[200],
    'graph-purple-gradient': colorDefinition.purple[100],
    'graph-pink': colorDefinition.pink[500],
    'graph-gray-dark': colorDefinition.gray[400],
    // 추가된 것 25/09/08 KT_DS Design System 참고
    // Header
    'hd-pt-bg-1depth': colorDefinition.white,
    'hd-pt-bg-2depth': colorDefinition.purple[700],
    'hd-ad-bg-1depth': colorDefinition.gray[900],
    'hd-ad-bg-2depth': colorDefinition.purple[700],
    'hd-pt-logo': colorDefinition.gray[900],
    'hd-pt-logo-text': colorDefinition.gray[900],
    'hd-pt-1depth-text-normal': colorDefinition.gray[700],
    'hd-pt-1depth-text-select': colorDefinition.gray[900],
    'hd-pt-2depth-text-normal': colorDefinition.gray[200],
    'hd-pt-2depth-text-select': colorDefinition.white,
    'hd-ad-2depth-text-normal': colorDefinition.gray[200],
    'hd-ad-2depth-text-select': colorDefinition.white,
    'hd-pt-border-select': colorDefinition.gray[900],
    'hd-pt-ic-dot-opacity-60%': colorDefinition.white,
    'hd-ad-ic-dot-opacity-60%': colorDefinition.white,
    // Background
    'bg-primary-opacity-40%': 'rgb(245, 240 ,255 ,40%)',
    'bg-secondary-lighter': colorDefinition.pink.ZERO,
    'bg-primary-lighter': colorDefinition.purple.ZERO,
    'bg-primary-light': colorDefinition.purple[500],
    'bg-primary': colorDefinition.purple[600],
    'bg-primary-dark': colorDefinition.purple[700],
    'bg-secondary': colorDefinition.pink[500],
    'bg-primary-light-50': colorDefinition.purple[200],
    'bg-cyan': colorDefinition.cyan[600],
    'bg-cyan-light': colorDefinition.cyan[400],
    'bg-meganta': colorDefinition.magenta[500],
    // State
    'state-white-primary-hover': '#F9F7FD',
    'state-white-primary-pressed': '#F3F0FA',
    'state-primary-hover': '#643EA9',
    'state-primary-pressed': '#6B47AC',
    // Border
    'border-secondary': colorDefinition.pink[500],
    'border-primary-light': colorDefinition.purple[200],
    'border-primary': colorDefinition.purple[500],
    'border-primary-dark': colorDefinition.purple[600],
    // Icon
    'ic-primary-light': colorDefinition.purple[500],
    'ic-primary': colorDefinition.purple[600],
    'ic-secondary-light': colorDefinition.pink[400],
    // Text
    'text-secondary': colorDefinition.pink[600],
    'text-primary': colorDefinition.purple[700],
    'text-primary-light': colorDefinition.purple[500],
    // Graph
    'graph-primary': colorDefinition.purple[500],
    'graph-primary-light': colorDefinition.purple[400],
    'graph-primary-lighter': colorDefinition.purple[200],
    'graph-secondary': colorDefinition.pink[500],
    'graph-secondary-light': colorDefinition.pink[300],
    // Primary
    'primary-000-40%': 'rgba(245, 240 ,255 ,40%)',
    'primary-200-20%': 'rgba(209, 188 ,249 ,20%)',
    'primary-200-0%': 'rgba(209,188,249 ,0%)',
  },
};

// ====== 회사별 테마 시스템 ======

// 회사별 브랜드 컬러 정의
export interface CompanyBrandColors {
  primary: Record<string, string>;
  secondary: Record<string, string>;
}

// 회사별 컬러 매핑 설정
export type CompanyThemeMapping = Partial<Record<keyof IColorSet, string>>;

// 회사별 테마 설정
export interface CompanyThemeConfig {
  brandColors: CompanyBrandColors;
  mapping: CompanyThemeMapping;
}

// 회사별 테마 설정들
export const companyThemes: Record<ThemeType, CompanyThemeConfig> = {
  // KT_DS 회사 - Cyan 테마
  KT_DS: {
    brandColors: {
      primary: colorDefinition.cyan,
      secondary: colorDefinition.magenta,
    },
    mapping: {
      'hd-pt-bg-1depth': colorDefinition.cyan[700],
      'hd-pt-bg-2depth': colorDefinition.gray[100],
      'hd-ad-bg-1depth': colorDefinition.cyan[700],
      'hd-ad-bg-2depth': colorDefinition.gray[900],
      'hd-pt-logo': colorDefinition.white,
      'hd-pt-logo-text': colorDefinition.white,
      'hd-pt-1depth-text-normal': colorDefinition.gray[200],
      'hd-pt-1depth-text-select': colorDefinition.white,
      'hd-pt-2depth-text-normal': colorDefinition.gray[700],
      'hd-pt-2depth-text-select': colorDefinition.gray[900],
      'hd-ad-2depth-text-normal': colorDefinition.gray[200],
      'hd-ad-2depth-text-select': colorDefinition.white,
      'hd-pt-border-select': colorDefinition.white,
      'hd-pt-ic-dot-opacity-60%': '#444D56',
      'hd-ad-ic-dot-opacity-60%': '#444D56',
      'bg-primary-opacity-40%': 'rgb(245, 240 ,255 ,40%)',
      'bg-secondary-lighter': colorDefinition.magenta.ZERO,
      'bg-primary-lighter': colorDefinition.cyan.ZERO,
      'bg-primary-light': colorDefinition.cyan[400],
      'bg-primary': colorDefinition.cyan[600],
      'bg-primary-dark': colorDefinition.cyan[700],
      'bg-secondary': colorDefinition.magenta[500],
      'bg-primary-light-50': colorDefinition.cyan[200],
      'bg-gradient': `linear-gradient(90deg, ${colorDefinition.magenta[700]} 0%, ${colorDefinition.cyan[600]} 100%);`,
      'state-white-primary-hover': '#F5FCFE',
      'state-white-primary-pressed': '#EBFAFC',
      'state-primary-hover': '#0FB2CD',
      'state-primary-pressed': '#0FB2CD',
      'border-secondary': colorDefinition.magenta[500],
      'border-primary-light': colorDefinition.cyan[200],
      'border-primary': colorDefinition.cyan[500],
      'border-primary-dark': colorDefinition.cyan[600],
      'ic-primary-light': colorDefinition.cyan[800],
      'ic-primary': colorDefinition.cyan[900],
      'ic-secondary-light': colorDefinition.magenta[400],
      'text-primary': colorDefinition.cyan[900],
      'text-secondary': colorDefinition.magenta[600],
      'text-primary-light': colorDefinition.cyan[800],
      'graph-primary': colorDefinition.cyan[500],
      'graph-primary-light': colorDefinition.cyan[400],
      'graph-primary-lighter': colorDefinition.purple[200],
      'graph-secondary': colorDefinition.magenta[500],
      'graph-secondary-light': colorDefinition.magenta[300],
      'primary-000-40%': 'rgba(222, 250 ,255 ,40%)',
      'primary-200-20%': 'rgba(209, 188 ,249 ,20%)',
      'primary-200-0%': 'rgba(209,188,249 ,0%)',
      'text-gradient': `linear-gradient(to left, ${colorDefinition.cyan[500]} 0%, ${colorDefinition.magenta[700]} 100% )`,
      'border-gradient': `linear-gradient(to left, ${colorDefinition.cyan[500]} 0%, ${colorDefinition.magenta[700]} 100% )`,
      'state-gradient-hover': `linear-gradient(90deg, ${colorDefinition.magenta[800]} 0%, ${colorDefinition.cyan[700]} 100%);`,
      'state-gradient-pressed': `linear-gradient(90deg, ${colorDefinition.magenta[800]} 0%, ${colorDefinition.cyan[700]} 100%);`,
    },
  },

  // 기본 테마 (Purple)
  DEFAULT: {
    brandColors: {
      primary: colorDefinition.purple,
      secondary: colorDefinition.pink,
    },
    mapping: {
      'hd-pt-bg-1depth': colorDefinition.white,
      'hd-pt-bg-2depth': colorDefinition.purple[700],
      'hd-ad-bg-1depth': colorDefinition.gray[900],
      'hd-ad-bg-2depth': colorDefinition.purple[700],
      'hd-pt-logo': colorDefinition.gray[900],
      'hd-pt-logo-text': colorDefinition.gray[900],
      'hd-pt-1depth-text-normal': colorDefinition.gray[700],
      'hd-pt-1depth-text-select': colorDefinition.gray[900],
      'hd-pt-2depth-text-normal': colorDefinition.gray[200],
      'hd-pt-2depth-text-select': colorDefinition.white,
      'hd-ad-2depth-text-normal': colorDefinition.gray[200],
      'hd-ad-2depth-text-select': colorDefinition.white,
      'hd-pt-border-select': colorDefinition.gray[900],
      'hd-pt-ic-dot-opacity-60%': colorDefinition.white,
      'hd-ad-ic-dot-opacity-60%': colorDefinition.white,
      'bg-primary-opacity-40%': 'rgb(245, 240 ,255 ,40%)',
      'bg-secondary-lighter': colorDefinition.pink.ZERO,
      'bg-primary-lighter': colorDefinition.purple.ZERO,
      'bg-primary-light': colorDefinition.purple[500],
      'bg-primary': colorDefinition.purple[600],
      'bg-primary-dark': colorDefinition.purple[700],
      'bg-secondary': colorDefinition.pink[500],
      'bg-primary-light-50': colorDefinition.purple[200],
      'bg-gradient': `linear-gradient(to left, ${colorDefinition.purple[500]} 0%, ${colorDefinition.pink[700]} 100% )`,
      'state-white-primary-hover': '#F9F7FD',
      'state-white-primary-pressed': '#F3F0FA',
      'state-primary-hover': '#643EA9',
      'state-primary-pressed': '#6B47AC',
      'border-secondary': colorDefinition.pink[500],
      'border-primary-light': colorDefinition.purple[200],
      'border-primary': colorDefinition.purple[500],
      'border-primary-dark': colorDefinition.purple[600],
      'ic-primary-light': colorDefinition.purple[500],
      'ic-primary': colorDefinition.purple[600],
      'ic-secondary-light': colorDefinition.pink[400],
      'text-primary': colorDefinition.purple[700],
      'text-secondary': colorDefinition.pink[600],
      'text-primary-light': colorDefinition.purple[500],
      'graph-primary': colorDefinition.purple[500],
      'graph-primary-light': colorDefinition.purple[400],
      'graph-primary-lighter': colorDefinition.purple[200],
      'graph-secondary': colorDefinition.pink[500],
      'graph-secondary-light': colorDefinition.pink[300],
      'primary-000-40%': 'rgba(245, 240 ,255 ,40%)',
      'primary-200-20%': 'rgba(209, 188 ,249 ,20%)',
      'primary-200-0%': 'rgba(209,188,249 ,0%)',
    },
  },
};

// 회사별 테마 생성 함수
export const createCompanyTheme = (companyThemeType: ThemeType, mode: ModeType = 'light'): IColorSet => {
  // 기본 색상 세트 복사
  let baseColors = { ...colors[mode] };

  if (companyThemeType === 'DEFAULT') {
    return baseColors;
  }

  // 회사 테마 설정 가져오기 (없으면 기본값 사용)
  const companyTheme = companyThemes[companyThemeType];
  // 커스텀 색상 오버라이드
  baseColors = { ...baseColors, ...companyTheme.mapping };

  return baseColors;
};

// 회사별 컬러 키 매핑 가져오기 함수
export const getCompanyColorMapping = (companyThemeType: ThemeType): CompanyThemeMapping => {
  const companyTheme = companyThemes[companyThemeType] || companyThemes.DEFAULT;
  return companyTheme.mapping;
};

// 편의 함수: 회사명과 용도로 색상 가져오기
export const getCompanyColor = (companyThemeType: ThemeType, purpose: keyof IColorSet): string => {
  const mapping = getCompanyColorMapping(companyThemeType);
  return mapping[purpose] || colors.light[purpose];
};
